<template>
    <div>
    <!--Bread Crumb Wrap Start-->
    <div class="kode_about_bg">
    	<div class="container">
        	<div class="kode_aboutus_wrap">
            	<h4>Data Agregat Kependudukan</h4>
				<div class="kode_bread_crumb">
                	<ul>
                		<li><a href="/">Home</a></li>
                    	<li><router-link to="/data_agregat_kependudukan">Data Agregat Kependudukan</router-link></li>
                	</ul>
                </div>
            </div>
        </div>
    </div>
    <!--Bread Crumb Wrap Start-->   
    
     
        
    <!--Content Wrap Start-->
    <div class="kode_content" style="padding-top:5%">
    	
        <!--News List Wrap Start-->
        <section >
        	<div class="container">
            	<div class="row">
                	<div class="col-md-8 kode_news_colmn_list">
                        <!-- list berita -->
                        <div class="kode_news_list" v-for="data in list_data" :key="data.id"> 
                            <div style="float:left;">
                                <a @click="GetData(data.id, data.judul, data.desk, data.isi, data.file)" data-toggle="modal" data-target="#myModal">
                                    <i class="fa fa-book" style="font-size:70px"> </i>
                                </a>
                            </div>

                            <div style="padding-left:10%">
                                <h6 style="font-size:95%"> <a @click="GetData(data.id, data.judul, data.desk, data.isi, data.file)" href="#" data-toggle="modal" data-target="#myModal"> <b>{{data.judul}}</b> </a> </h6>
                                <div>by <a href="#">{{data.createBy}} </a>
                                  <br><i class="fa fa-calendar"></i> Tanggal Rilis  - {{convert_tgl(data.createAt)}}</div>
                                <p v-html="data.isi"></p>
                            </div>
                        </div>
                        
                        <!-- list berita -->
                        
                        
 
						<div class="clearfix clear"></div>
						<!--Pagination Wrap Start-->
						<div class="kode_pagination">
							<ul class="pagination">
                                    <div class="text-center">
										<button @click="btn_prev" type="button" class="btn " id="pref">
											<span aria-hidden="true">&laquo;</span><span class="sr-only">Previous</span>
										</button>
										&nbsp;
										<span style="font-size: 85%; color: #a5a5a5">
											<b>{{page_first}} - {{page_last}}</b>
										</span>
										&nbsp;
										<button @click="btn_next" type="button" class="btn" id="next">
											<span aria-hidden="true">&raquo;</span><span class="sr-only">Next</span>
										</button>
									</div>
						
							</ul>
						</div>
						<!--Pagination Wrap End-->
                    </div>
                    
                    <div class="col-md-4">
                    	<div class="kode_aside_search">
                        	<form>
                            	<input id="search" type="text" placeholder="Search ..." @keyup="cari_data" v-model="cari_value">
                                <button><i class="fa fa-search"></i></button>
                            </form>
                        </div>
                        
 
                        
						<!--Aside Event Wrap Start-->
                        <div class="kode_aside_event kode_aside">
                        	<h5>Kegiatan</h5>
                            <ul>
                            	<li v-for="data in kegiatan" :key="data.id">
                                	<figure>
                                    	<img :src="file_path+data.foto" alt="Image Here">
                                        <figcaption>
                                         
                                            <a href="javascript:void(0);" @click="push_kegiatan(data.id)"><i class="fa fa-link"></i></a>
                                        </figcaption>
                                    </figure>
                                    <div class="kode_aside_event_des" style="text-align:justify">
                                    	<p v-html="limit_desk_kegiatan(data.deskripsi)+' ...'"> </p>
                                    	<span><b>{{convert_tgl(data.createAt)}}</b></span>
                                    </div>
                                </li>
                                
 
                            </ul>
                        </div>
                        <!--Aside Event Wrap End-->
						
 
                        
 
                        
						<!--Aside Flicker Wrap Start-->
                        <div class="kode_aside_flicker kode_aside">
                        	<h5>Galleri Kegiatan</h5>
                        	<ul>
                            	<li v-for="data in kegiatan6" :key="data.id">
                                	<a href="javascript:void(0);" @click="push_kegiatan(data.id)">
                                		<figure>
                                    		<img :src="file_path+data.foto" alt="Image Here" style="height:90px;width:100%">
                                            <figcaption>
                                            	<i class="fa fa-plus"> </i>
                                            </figcaption>
                                    	</figure>
                                	</a>
                                </li>
                                
 
                            </ul>
                        </div>
						<!--Aside Flicker Wrap End-->
                        
                    </div>
                    
                    
                </div> 

                <!-- Button trigger modal -->


                <!-- Modal -->
                <div class="modal fade" id="myModal" role="dialog" aria-labelledby="myModalLabel" >
                <div class="modal-dialog modal-lg" role="document" >
                    <div class="modal-content" >
                    <div class="modal-header" >
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h6 class="modal-title" id="myModalLabel" ><small><b>LIHAT DATA</b></small></h6>
                    </div>
                    <div class="modal-body">

                         <h6><b> {{judul}} </b> </h6>
                        <hr>
                        <div class="text-center" v-if="file_tampil">
                            <embed :src="file_path+file" width="850" height="800" 
                            type="application/pdf">
                        </div>
                        <hr>
                        <p v-html="isi"></p>
                        
                    </div>
                    <div class="modal-footer" >
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-default" style="background-color:#ef4a2b;color:#fff">Download</button>
                    </div>
                    </div>
                </div>
                </div>

                
            </div>
        </section>
        <!--News List Wrap End-->
        
    </div>
    <!--Content Wrap End-->
    </div>
</template>



<script>

// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import {ImageResize} from 'quill-image-resize-module'
// Quill.register('modules/imageResize', ImageResize)


// Quill.register("modules/imageResize", ImageResize);

const ADD_URL = URL_APP + "api/v1/publish_data_kependudukan/";
const KEGIATAN_URL = URL_APP + "api/v1/publish_kegiatan/";
const FILE_LOAD = URL_APP + "uploads/";

export default {
  name: "web_pengumuman",
  data() {
    return {
		id: "",
		id_berita :"",
		createAt : '',
		createBy : '',
		desk : '',
		isi : '',
		judul : '',
		sumber : '',
		foto : '',
		HOST : URL_HOST+'/isi_berita/',
		file_path: FILE_LOAD,
    
    kegiatan:[],
    kegiatan6:[],

		list_data: [],
		page_first: 1,
		page_last: 0,
		cari_value: "",


    };
  },

  // =============================================================== METHODS =========================================================================
  // =============================================================== METHODS =========================================================================
  methods: {
    getView: function() {
      fetch(ADD_URL + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
            // console.log(res_data);
        });
	},

	
    getOne: function() {
      fetch(ADD_URL + "getOne", {
        method: "get",
        headers: {
          "content-type": "application/json",
        },

      })
        .then(res => res.json())
        .then(res_data => {
        //   this.list_data = res_data.data;
        //   this.page_last = res_data.jml_data;
			// console.log(res_data);

            var berita = res_data[0];
            
            this.id_berita = berita.id;
            this.createAt = berita.createAt;
            this.createBy = berita.createBy;
            this.desk = berita.desk;
            this.isi = berita.isi;
            this.judul = berita.judul;
            this.sumber = berita.sumber;
            this.foto = berita.foto;    



        });
  },
  
        getKegiatan: function() {
        fetch(KEGIATAN_URL + "getOne", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan = res_data;
                //   console.log(res_data);
            });
    },    

        getKegiatan6: function() {
        fetch(KEGIATAN_URL + "get6", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan6 = res_data;
                //   console.log(res_data);
            });
    },     

    limit_desk_kegiatan : function(text){
    return text.substring(0, 100)
    }, 

	push_kegiatan : function(id){
		this.$router.push('/isi_kegiatan/'+id);
    },
	
	push_berita : function(id){
		this.$router.push('/isi_berita/'+id);
	},

	to_facebook : function () {
        window.open("http://www.facebook.com/sharer.php?u="+this.HOST+this.id_berita, '_blank');
    },
    to_twitter : function(){
        // alert(this.HOST)
        window.open("https://twitter.com/share?url="+this.HOST+this.id_berita+"&amp;text="+this.judul, '_blank');
    },


    GetData: function(id, judul, desk, isi, file) {
      this.id = id;
      this.judul = judul;
      this.desk = desk;
      this.isi = isi; 

      this.file = file;
      this.file_old = file;


      if (file == '') {this.file_tampil = false;}
      else{this.file_tampil = true;}
      

    },



// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function() {
      this.getView();
    },

    convert_tgl : function(dateString){
		var date = new Date(dateString);
		var bulan = "";

		if (date.getMonth() == 0) {bulan = 'januari';} 
		else if (date.getMonth() == 1) {bulan = 'Februari';}
		else if (date.getMonth() == 2) {bulan = 'Maret';}
		else if (date.getMonth() == 3) {bulan = 'April';}
		else if (date.getMonth() == 4) {bulan = 'Mei';}
		else if (date.getMonth() == 5) {bulan = 'Juni';}
		else if (date.getMonth() == 6) {bulan = 'Juli';}
		else if (date.getMonth() == 7) {bulan = 'Agustus';}
		else if (date.getMonth() == 8) {bulan = 'September';}
		else if (date.getMonth() == 9) {bulan = 'Oktober';}
		else if (date.getMonth() == 10) {bulan = 'November';}
		else if (date.getMonth() == 11) {bulan = 'Desember';}
		else{bulan = ''}

		return date.getDate()+" "+bulan+" "+date.getFullYear();
	},
// ================== PAGINASI ====================
  },
  // =============================================================== METHODS =========================================================================

  mounted() {
	this.getView();
	this.getOne();
  this.getKegiatan();
	this.getKegiatan6();
  }
};
</script>